import { TemplateRef } from "@angular/core";
import { Observable } from "rxjs";
import { NzSafeAny } from "ng-zorro-antd/core/types";
import { NzDrawerPlacement, NzDrawerRef } from "ng-zorro-antd/drawer";

export abstract class DrawerRef<T = NzSafeAny, R = NzSafeAny> extends NzDrawerRef {
  abstract afterClose: Observable<R>;
  abstract afterOpen: Observable<void>;
  abstract close(result?: R): void;
  abstract open(): void;
  abstract getContentComponent(): T | null;
  abstract drawerClosable?: boolean;
  abstract drawerNoAnimation?: boolean;
  abstract drawerMaskClosable?: boolean;
  abstract drawerKeyboard?: boolean;
  abstract drawerMask?: boolean;
  abstract drawerTitle?: string | TemplateRef<unknown>;
  abstract drawerPlacement?: NzDrawerPlacement;
  abstract drawerMaskStyle?: object;
  abstract drawerBodyStyle?: object;
  abstract drawerWrapClassName?: string;
  abstract drawerWidth?: number | string;
  abstract drawerHeight?: number | string;
  abstract drawerZIndex?: number | string;
  abstract drawerOffsetX?: number | string;
  abstract drawerOffsetY?: number | string;
}
